<template>
  <div id="homeTitle" style="width: 100%; height: 50px; background-color: #101844; color: white; font-size: 30px; font-family: 黑体;  text-align: center;">
    <span style="line-height: 50px; left: 90px; position: relative; color: white; ">{{areaName}}人防警报系统巡检/维修平台</span>
    <el-button  @click="exit" style="width: 60px; ">
      <i id="exitIcon" style="color: white;" class="el-icon-s-home"></i>
    </el-button>
    <el-button  @click="switchScreen" style="width: 60px;">
      <i id="refreshIcon" style="color: white;" class="el-icon-refresh"></i>
    </el-button>
    <el-button  @click="handleFullScreen" style="width: 60px;">
      <i  style="color: white; transform: rotate(45deg)" class="el-icon-rank"></i>
    </el-button>

  </div>
</template>

<script>
export default {
  name: 'HomeTitle',
  props:['areaName'],
  data(){
    return {


    }
  },
  methods: {
    switchScreen(){
      console.log('切换屏幕');
      this.$router.push('/bigScreen2');
    },
    handleFullScreen(){
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    refresh(){
      console.log('refresh');
      // let refreshIcon = document.getElementById('refreshIcon');
      // refreshIcon.style.transform = 'rotate(180deg)';
    },
    exit(){
      this.$router.push('/map');
    }
  },
  mounted(){

  }
}
</script>

<style scoped>
  .el-button{
    background-color: #101844; border: none; position: relative; float: right;
    font-size: 24px;
  }
  .el-button i {
    color: white;
  }
</style>
